import { ESDateNow, IDateNow, IMockDateNow, MockDateNow, isTestEnvironmentRunning } from "sonobello.utilities.react";

/** The instance of {@link DateNow} which is used by any application code when running Cypress. */
export const TestingDateNow: IDateNow & IMockDateNow = new MockDateNow();

/** The abstracted instance of the ES Date utility that should be used by application code. */
const DateNow: IDateNow = isTestEnvironmentRunning() ? TestingDateNow : new ESDateNow();

export default DateNow;
